module.exports = __webpack_public_path__ + "img/no-bicycles.66d7ec71.png";